module.exports = __webpack_public_path__ + "img/ykk.52da44cd.png";